import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import type { AzureRow } from './azure';
import { formatCost } from './lib';

/** Per-resource drill-down for one environment's Azure row, rendered inside
 * the Table's `detailPanel`. One row per ARM resource — never an ARM
 * resource ID. */
export const AzureResourceDetail = ({ row }: { row: AzureRow }) => {
  const categories = Object.entries(row.byCategory).sort((a, b) => b[1] - a[1]);

  return (
    <Box p={2} bgcolor="background.default">
      {categories.length > 0 && (
        <Box mb={row.resources.length > 0 ? 2 : 0}>
          <Typography variant="subtitle2" gutterBottom>
            By category
          </Typography>
          <Table size="small">
            <TableBody>
              {categories.map(([category, cost]) => (
                <TableRow key={category}>
                  <TableCell>{category}</TableCell>
                  <TableCell align="right">{formatCost(cost)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}

      {row.resources.length > 0 && (
        <Box>
          <Typography variant="subtitle2" gutterBottom>
            Resources
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Resource</TableCell>
                <TableCell>Resource group</TableCell>
                <TableCell align="right">Cost</TableCell>
                <TableCell>Categories</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {row.resources.map((resource, index) => (
                <TableRow key={`${resource.resourceGroup}/${resource.name}/${index}`}>
                  <TableCell>{resource.name}</TableCell>
                  <TableCell>{resource.resourceGroup}</TableCell>
                  <TableCell align="right">{formatCost(resource.cost)}</TableCell>
                  <TableCell>
                    {Object.entries(resource.byCategory)
                      .sort((a, b) => b[1] - a[1])
                      .map(([category, cost]) => `${category} (${formatCost(cost)})`)
                      .join(', ')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}
    </Box>
  );
};
